import axios from 'axios';

async function ObtenerSocios() {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_socios"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!"
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerSocios;